import React from 'react';
import { event, solution } from '../data/masterclass';
export function Solution() {
  return <section aria-labelledby="solution-heading" className="border-t border-ink-line bg-ink" data-id="element-118" data-mp="1el3zhv5kosds">
      <div className="mx-auto flex w-full max-w-5xl flex-col items-center px-6 py-16 text-center lg:py-20" data-id="element-119" data-mp="10tz8fhg9t8f2">
        <h2 id="solution-heading" className="font-display text-5xl font-bold uppercase leading-[0.95] text-gold sm:text-6xl lg:text-7xl" data-id="element-120" data-mp="15r8x2uvu5g1u">
          {event.brand}
        </h2>
        <p className="mt-5 text-sm font-semibold uppercase tracking-overline text-white" data-id="element-121" data-mp="vuw3ry47d47m">
          {event.brandPillars}
        </p>
        <p className="mt-4 font-display text-2xl font-bold uppercase tracking-[0.1em] text-white/80 sm:text-3xl" data-id="element-122" data-mp="hwelwh0zalxm">
          {event.trademark}
        </p>

        <p className="mt-10 max-w-3xl text-xl leading-relaxed text-white/70 sm:text-2xl" data-id="element-123" data-mp="2c9e4mj0nnw94">
          {solution.body}
        </p>
      </div>
    </section>;
}